<template>
  <div ref="bottomLeft" class="warp"></div>
</template>
<script type="text/javascript" scoped>
  export default {
    name: 'home',
    props: {
      data: {
        type: Object,
        default: () => {}
      },
    },
    data () {
      return {}
    },
    mounted() {
      this.initOption();
    },
    methods: {
      initOption() {
        // initOption 作用： 一次性捕获 echats 图表的挂载点，声明好 echats 图表的 基本配置
        this.chart = this.$echarts.init(this.$refs.bottomLeft);
        this.option = {
          backgroundColor: '#012422',
          color: ['#18606e'],
          tooltip : {
            trigger: 'axis',
            axisPointer : {            // 坐标轴指示器，坐标轴触发有效
              type : 'shadow'        // 默认为直线，可选为：'line' | 'shadow'
            },
            formatter: function (params, ticket, callback) {
              return "<div style='text-align: left'>"+params[0].name+"年<br>土壤有机物质含量"+params[0].value+"<br>同比增长率     "+params[1].value+"%</div>";
            }
          },
          grid: {
            right: '8%',
            left: '15%',
            bottom: '15%',
            top: '15%'
          },
          legend: {
            show: true,
            y:'top',
            x: 'center',
            height:10,
            padding:[10,0,0,0],
            data: [{
              name: '土壤有机物质含量',
              icon: 'rect',
            },
              {
              name: '同比增长率',
              icon: 'circle',
            }],
            textStyle: {
              color:'#fff'
            }
          },
          xAxis : [
            {
              type : 'category',
              data : ['2011', '2012', '2013', '2014', '2015', '2016', '2017'],
              axisTick: {
                show: false
              },
              axisLabel: {
                show:true,
                color: '#fff',
                fontSize: 16,
              },
              axisLine: {
                lineStyle: {
                  color: '#124886',
                }
              },
              splitLine: {
                show:false,
              },

            }
          ],
          yAxis : [
            {
              type : 'value',
              name: '含量(g*kg-1)',
              min:0,
              max:45,
              interval: 5,
              nameTextStyle:{
                color:'#99ffcc',
                fontSize: 12,
              },
              axisTick: {
                show: false
              },
              axisLabel: {
                show:true,
                fontSize: 16,
                color: '#fff'
              },
              splitLine: {
                show:false,
              },
              axisLine: {
                lineStyle: {
                  color: '#124886'
                }
              },
            },
            {
              type: 'value',
              name: '同比增长率(%)',
              min: 0,
              max: 9,
              interval: 1,
              nameTextStyle:{
                color:'#99ffcc',
                fontSize: 12,
              },
              axisTick: {
                show: false
              },
              axisLabel: {
                show:true,
                formatter: '{value} %',
                fontSize: 16,
                color: '#fff'
              },
              splitLine: {
                show:false,
              },
              axisLine: {
                lineStyle: {
                  color: '#124886'
                }
              },
            }
          ],
          series : [
            {
              name: '土壤有机物质含量',
              type: 'bar',
              stack: '万亩',
              barWidth : 15,
              itemStyle: {
                normal: {
                  borderColor: '#05b8ff',
                  borderWidth: 1,
                }
              },
              label: {
                normal: {
                  show: false
                }
              },
              data: [14, 28, 20, 33,25,42,38]
            },
            {
              name: '同比增长率',
              type: 'line',
              yAxisIndex: 1,
              symbol: 'circle',
              lineStyle: {
                normal: {
                  color: '#c85307'
                }
              },
              itemStyle: {
                normal: {
                  color: '#ff8212',
                  borderColor: '#eccf3e',
                  borderWidth: '2',
                },
              },

              data: [3, 6, 4, 7, 5, 8.3, 7.8],
              symbolSize: 10
            }
          ]
        };
        this.chart.setOption(this.option, true);
        let self=this;
        window.addEventListener('resize', function () {
          self.chart.resize();
        })
      }
    }
  }
</script>
<style lang="scss" scoped>
  .warp{
    width: 100%;
    height: 100%;
  }
</style>



// WEBPACK FOOTER //
// src/components/echarts/qualityAnalysistime.vue